<template>
  <div class="historial-resumen">
    <b-card>
      <b-row>
        <b-col md="3">
          <v-select
            :options="listCampeonatos"
            @input="changeCampeonato"
            placeholder="Selecciona Campeonato"
            :clearable="false"
            v-model="campeonatoSeleccionado"
          />
        </b-col>
        <b-col md="3">
          <v-select
            :options="listHistoriales"
            @input="changeHistorial"
            placeholder="Selecciona Historial"
            :clearable="false"
            v-model="historialSeleccionado"
          />
        </b-col>
      </b-row>
      <b-row v-if="historialSeleccionado.value !== null">
        <b-col>
          <div class="demo-inline-spacing">
            <b-form-radio v-model="tipoReporte" name="some-radios" value="A">
              Resumen x Equipo
            </b-form-radio>
            <b-form-radio v-model="tipoReporte" name="some-radios" value="B">
              Resumen x Hora
            </b-form-radio>
            <b-form-radio v-model="tipoReporte" name="some-radios" value="C">
              Resumen x Día
            </b-form-radio>
          </div>
        </b-col>
      </b-row>
      <div>
        <b-overlay :show="showLoading" rounded opacity="0.6">
          <TableResumenEquipo v-if="tipoReporte === 'A'" :resumen="resumen" />
          <TableResumenHoras
            v-if="tipoReporte === 'B'"
            :equipos="resumenHoras"
            :horas="horas"
          />
          <TableResumenDiaHora
            v-if="tipoReporte === 'C'"
            :historial="resumenDiaHora"
          />
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import { onMounted, ref, watch } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {
  // BTabs,
  // BTab,
  BCard,
  BRow,
  BCol,
  // BButton,
  BFormRadio,
  BOverlay,
  // VBTooltip,
  // BOverlay,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from 'bootstrap-vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  // USER,
  // ROLES,
  // DISCIPLINAS,
  // ACTION_INSERT
} from '../../utils/variables'
import TableResumenEquipo from './TableResumenEquipo.vue'
import TableResumenHoras from './TableResumenHoras.vue'
import TableResumenDiaHora from './TableResumenDiaHora.vue'

export default {
  components: {
    BCard,
    vSelect,
    TableResumenEquipo,
    // BTabs,
    // BTab,
    BRow,
    BCol,
    BFormRadio,
    TableResumenHoras,
    TableResumenDiaHora,
    BOverlay,
    // VBTooltip,
    // BOverlay,
  },
  directives: {
    Ripple,
    // 'b-tooltip': VBTooltip,
  },
  props: {
    // resumen: {
    //   type: Array,
    //   default: () => [],
    // },
  },

  setup() {
    const diasSemana = [
      'lunes',
      'martes',
      'miercoles',
      'jueves',
      'viernes',
      'sabado',
      'domingo',
    ]
    const { getApi } = apiCall()
    const listCampeonatos = ref([])
    const listHistoriales = ref([])
    const resumen = ref([])
    const resumenHoras = ref([])
    const resumenDiaHora = ref({})
    const horas = ref([])
    const tipoReporte = ref(null)
    const showLoading = ref(false)
    const historialSeleccionado = ref({
      label: 'Seleccione Historial',
      value: null,
    })
    // const showContenedor = ref(false)
    const campeonatoSeleccionado = ref({
      label: 'Seleccione campeonato',
      value: null,
    })
    async function getHistoriales() {
      listHistoriales.value = []
      historialSeleccionado.value = {
        label: 'Seleccione Historial',
        value: null,
      }

      // isCreando.value = true
      // showLoadingModal.value = true
      const path = `ApiConfiguration/getHistorialesXCampeonato/${campeonatoSeleccionado.value.value}`
      const data = await getApi(URL, path)
      listHistoriales.value = data
      // showLoadingModal.value = false
    }
    function changeCampeonato() {
      historialSeleccionado.value = {
        label: 'Seleccione Historial',
        value: null,
      }
      resumen.value = []
      resumenHoras.value = []
      resumenDiaHora.value = {}
      tipoReporte.value = null
      getHistoriales()
    }
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    onMounted(() => {
      // getP()
      // getListCategorias(
      //   // eslint-disable-next-line
      //   store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      // )
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
      const campActivo = listCampeonatos.value.find(
        // eslint-disable-next-line
        element => element.activo === 's',
      )
      campeonatoSeleccionado.value = campActivo
      getHistoriales()
    })

    const changeHistorial = async () => {
      // resumen.value = []
      // const path = `ApiFixture/resumenEquipos/${historialSeleccionado.value.value}`
      // const data = await getApi(URL, path)
      // resumen.value = data
      // console.log('data')
    }
    const cargarResumenDiaHora = async () => {
      resumenDiaHora.value = {}
      showLoading.value = true
      const path = `ApiFixture/resumenDiaHora/${historialSeleccionado.value.value}`
      const data = await getApi(URL, path)
      resumenDiaHora.value = data
      showLoading.value = false
      // console.log(data)
    }
    const cargarResumenEquipos = async () => {
      resumen.value = []
      showLoading.value = true
      const path = `ApiFixture/resumenEquipos/${historialSeleccionado.value.value}`
      const data = await getApi(URL, path)
      resumen.value = data
      showLoading.value = false

      // console.log(data)
    }
    const cargarResumenHorarios = async () => {
      resumenHoras.value = []
      showLoading.value = true
      const path = `ApiFixture/resumenHoras/${historialSeleccionado.value.value}`
      const data = await getApi(URL, path)
      resumenHoras.value = data.equipos
      horas.value = data.horas
      showLoading.value = false
      // console.log(data)
    }
    watch(tipoReporte, nuevo => {
      // console.log('cambió:', anterior, '→', nuevo)

      if (nuevo === 'A') {
        // cargar resumen por equipo
        cargarResumenEquipos()
      }

      if (nuevo === 'B') {
        // cargar resumen por hora
        cargarResumenHorarios()
      }

      if (nuevo === 'C') {
        cargarResumenDiaHora()
        // cargar resumen por día
      }
    })
    // listDias.value = [{ dia: '' }]
    // listFranjas.value = [{ hora: '' }]
    // listPartidos.value = {}
    // listCanchas.value = []
    // showLoadingContenido.value = false
    // fechaPartido.value = ''
    // auditoriaSeleccionada.value = {
    //   label: 'Seleccione generacion',
    //   value: null,
    // }
    return {
      diasSemana,
      changeHistorial,
      historialSeleccionado,
      changeCampeonato,
      listCampeonatos,
      campeonatoSeleccionado,
      listHistoriales,
      resumen,
      tipoReporte,
      resumenHoras,
      horas,
      resumenDiaHora,
      showLoading,
    }
  },
}
</script>

<style scoped></style>
